const possibleBases = [
  "Absolut Citron",
  "Ale",
  "Amaretto",
  "Apple brandy",
  "Applejack",
  "Apricot brandy",
  "Añejo rum",
  "Blackberry brandy",
  "Blended whiskey",
  "Bourbon",
  "Brandy",
  "Champagne",
  "Cherry brandy",
  "Chocolate liqueur",
  "Cider",
  "Coffee brandy",
  "Coffee liqueur",
  "Cognac",
  "Creme de Cacao",
  "Creme de Cassis",
  "Dark rum",
  "Dry Vermouth",
  "Dubonnet Rouge",
  "Everclear",
  "Firewater",
  "Galliano",
  "Gin",
  "Grenadine",
  "Irish cream",
  "Irish whiskey",
  "Johnnie Walker",
  "Kahlua",
  "Lager",
  "Lemon vodka",
  "Light rum",
  "Midori melon liqueur",
  "Orange bitters",
  "Ouzo",
  "Peach Vodka",
  "Peppermint schnapps",
  "Pisco",
  "Port",
  "Red wine",
  "Ricard",
  "Rum",
  "Sambuca",
  "Scotch",
  "Sherry",
  "Sloe gin",
  "Southern Comfort",
  "Spiced rum",
  "Strawberry schnapps",
  "Sweet Vermouth",
  "Tea",
  "Tequila",
  "Triple sec",
  "Vodka",
  "Whiskey"
]

export default possibleBases
